@if (attachments.controls.length) {
  <div class="main-container">
    @for (attachment of attachments.controls; track trackByIndex($index)) {
      <div
        [class.selected]="attachment.isSelected.value"
        (click)="attachment.isSelected.setValue(!attachment.isSelected.value)"
        class="attachment-card"
      >
        <mat-checkbox
          (click)="$event.stopPropagation()"
          color="primary"
          [formControl]="attachment.isSelected"
        ></mat-checkbox>
        @if (!contractFileTypes?.length || !attachment.contractFileType.value) {
          <span>
            {{ attachment.name.value }}
          </span>
        } @else {
          <div class="flex column">
            <span>{{ attachment.title.value ?? attachment.name.value }}</span>
            <div class="separator"></div>
            <span class="attachment-type">
              {{ attachment.contractFileType.value | codeAndLabel: contractFileTypes }}
            </span>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="empty-state">Aucune pièce jointe disponible</div>
}
